import * as React from "react";
import {DashboardUser, GroupPermission} from "../../../generated/protocol";
import {AppCtx} from "../../ioc/ApplicationContext";
import {DashboardUserService} from "../../service/DashboardUserService";
import {LoginForm} from "../user/LoginForm";
import * as AltContainer from "alt-container";
import {MainMenu} from "../navbar/MainMenu";
import {Forbidden} from "../error/Forbidden";


interface State {
    user?: DashboardUser;
    forbiddenError: boolean;
    containerClasses?: String;

}

export class MainTemplate extends React.Component<{ location: Location, routes: any, permissions: { [key: string]: GroupPermission } }, State> {

    dashboardUserService: DashboardUserService;

    constructor() {
        super();
        this.state = {user: null, forbiddenError: false};

    }

    componentDidMount() {
        console.log("Main template : ", this.props);
        AppCtx.getUserStore().listen((s) => {
            this.setState({user: s.user, forbiddenError: s.displayRequestForbidden});
        });
        AppCtx.getUserActions().getUserInfo();
    }


    getContainerClass(): string {
        return "";
    }

    getPage() {
        if (this.state.forbiddenError == true) {
            return <Forbidden/>;
        } else {
            return <div>{this.props.children}</div>;
        }
    }

    toggleNav() {
        let toggled = "md-skin fixed-sidebar pace-done body-small mini-navbar";
        if (!$("body").hasClass("mini-navbar")) {
            $("body").prop("class", toggled);
        } else {
            $("body").prop("class", "md-skin");
        }
    }

    getContent() {
        if (this.state.user == null) {
            return <div/>;
        }

        return (
            <div id="wrapper" className={this.getContainerClass()}>

                <AltContainer store={AppCtx.getUserStore()}>
                    <MainMenu location={this.props.location} routes={this.props.routes}
                              permissions={this.props.permissions}/>
                </AltContainer>

                <div id="page-wrapper" className="gray-bg dashbard-1">
                    <div className="row border-bottom">
                        <nav className="navbar navbar-static-top" role="navigation">
                            <div className="navbar-header">
                                <a className="navbar-minimalize minimalize-styl-2 btn btn-primary "
                                   onClick={this.toggleNav.bind(this)}>
                                    <i className="fa fa-bars"></i>
                                </a>
                            </div>
                            <ul className="nav navbar-top-links navbar-right">
                                <li>
                                    <span className="m-r-sm text-muted welcome-message">Cubeia Dashboard</span>
                                </li>
                                <li>
                                    <a href="#" onClick={() => {
                                        AppCtx.getUserActions().logout()
                                    }}>
                                        <i className="fa fa-sign-out"></i> Log out
                                    </a>
                                </li>
                            </ul>

                        </nav>
                    </div>
                    {this.getPage()}

                </div>

            </div>
        );
    }

    render() {
        var visibleStyles = {
            position: "absolute",
            top: 0,
            left: 0,
            overflow: "hidden",
            width: "100%",
            height: "100%"
        }

        return (
            <div>
                <AltContainer store={AppCtx.getUserStore()}>
                    <LoginForm/>
                </AltContainer>
                {this.getContent()}
            </div>


        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/MainTemplate.tsx